export var DataCatalogMaskTransformKind;
(function (DataCatalogMaskTransformKind) {
    DataCatalogMaskTransformKind["DATA_CATALOG_MASK_TRANSFORM_KIND_NULLIFY"] = "NULLIFY";
    DataCatalogMaskTransformKind["DATA_CATALOG_MASK_TRANSFORM_KIND_DEFAULT_VALUE"] = "DEFAULT_VALUE";
    DataCatalogMaskTransformKind["DATA_CATALOG_MASK_TRANSFORM_KIND_SHA256"] = "SHA256";
})(DataCatalogMaskTransformKind || (DataCatalogMaskTransformKind = {}));
